import { implementCustomExpressions } from '../__generated/implementation.js';
import { FenixVariant } from '../__generated/model/index.js';
import { AVAILABLE_LEG_TYPES_RECTANGLE } from './top-rectangle.js';
export const topHalfOvalExpressions = implementCustomExpressions({
    TopHalfOval: {
        $objectName: (self)=>self.fenixVariant === FenixVariant.Birch ? 'FENIX_HALF_OVAAL_HALF_OVAL' : 'HALF_OVAAL_HALF_OVAL',
        $availableLegTypes: ()=>AVAILABLE_LEG_TYPES_RECTANGLE
    }
});

//# sourceMappingURL=top-half-oval.js.map